export default {
  name: 'TsCard',
  functional: true,
  render(h, context) {
    return (
      <div
        {...{
          class: ['widget widget-rounded', context.data.staticClass, , context.data.class],
          style: context.data.staticStyle,
          attrs: context.data.attrs,
          directives: context.data.directives
        }}
      >
        {context.children}
      </div>
    )
  }
}
